/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Exports
*/

/**
 * 
 */
export function Button({ label, className, formik, ...props }) {
  /** Settings **/
  
  const config = {
    className: CssClassName(className),
    ...props
  };

  /** Output **/

  return (
    <button { ...config }>
      {
        typeof label === 'function'
          ? label()
          : label
      }
    </button>
  );
}

Button.propTypes = {
  type: PropTypes.string,
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  label: PropTypes.oneOfType([ PropTypes.string, PropTypes.func ]),
  formik: PropTypes.object
};

Button.defaultProps = {
  type: 'button'
};